<div
  class="iccd-tab-container"
  [formGroup]="form">
  <div class="card-tab-form content">
    <mat-form-field [class.error]="form?.controls?.codiceUnico.invalid && (form?.controls?.codiceUnico.dirty || form?.controls?.codiceUnico.touched)">
      <input
        matInput
        required
        placeholder="Codice Unico"
        formControlName="codiceUnico">
      <mat-error *ngIf="form?.controls?.codiceUnico.hasError('required')">Codice Unico obbligatorio</mat-error>
      <mat-error *ngIf="form?.controls?.codiceUnico.hasError('duplicate')">Codice Unico già esistente</mat-error>
    </mat-form-field>
    <app-input-vocabulary-autocomplete
      *ngIf="form?.controls?.tipoOperaFiglia && !isOperaMadre"
      formControlName="tipoOperaFiglia"
      [vocabularyName]="'V_TipoOperaFiglia'"
      [placeholder]="'Tipo opera figlia'">
    </app-input-vocabulary-autocomplete>
    <mat-form-field formGroupName="SGT">
      <input
        matInput
        placeholder="Titolo soggetto (SGTT)"
        formControlName="SGTT">
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.numeroEsemplare">
      <input
        matInput
        placeholder="Numero Esemplare"
        formControlName="numeroEsemplare">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Tipo scheda (TSK)"
        formControlName="TSK">
    </mat-form-field>

    <mat-card
      *ngIf="form?.get('DT')"
      class="iccd-card-container">
      <mat-card-title title="Cronologio (DT)">{{ 'Cronologia' }}</mat-card-title>
      <mat-card-content>
        <app-dt-form
          [classNames]="classNames"
          [form]="form?.get('DT')"></app-dt-form>
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="form?.get('MTC')"
      class="iccd-card-container">
      <mat-card-title title="Materia e Tecnica (MTC)">{{ 'Materia e Tecnica' }}</mat-card-title>
      <mat-card-content>
        <ng-container [ngTemplateOutlet]="iccdTemplate?.MTC || defaultMTCTemplate"></ng-container>
        <ng-template #defaultMTCTemplate>
          <app-mtc-form
            [form]="form?.get('MTC')"
            [classNames]="classNames"
            [context]="{ TSK: form?.controls?.TSK.value }">
          </app-mtc-form>
        </ng-template>
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="form?.get('MIS')"
      class="iccd-card-container">
      <mat-card-title title="Misure (MIS)">{{ 'Misure' }}</mat-card-title>
      <mat-card-content>
        <app-mis-form
          [classNames]="classNames"
          [form]="form?.get('MIS')">
        </app-mis-form>
      </mat-card-content>
    </mat-card>

    <mat-form-field>
      <textarea
        matInput
        placeholder="Osservazioni (OSS)"
        formControlName="OSS"></textarea>
    </mat-form-field>

    <mat-card
      *ngIf="form?.get('LA')"
      class="iccd-card-container">
      <mat-card-title title="Localizzazioni (LA)">{{ 'Localizzazioni' }}</mat-card-title>
      <mat-card-content>
        <app-la-form
          [classNames]="classNames"
          [form]="form?.get('LA')">
        </app-la-form>
      </mat-card-content>
    </mat-card>

    <mat-form-field>
      <input
        matInput
        placeholder="Ente schedatore (ESC)"
        formControlName="ESC">
    </mat-form-field>

    <mat-card
      *ngIf="form?.get('CMP')"
      class="iccd-card-container">
      <mat-card-title title="Compilazione (CMP)">{{ 'Compilazione' }}</mat-card-title>
      <mat-card-content>
        <app-cmp-form [form]="form?.get('CMP')"></app-cmp-form>
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="form?.get('AUT')"
      class="iccd-card-container">
      <mat-card-title title="Autore (AUT)">{{ 'Autore' }}</mat-card-title>
      <mat-card-content>
        <app-aut-form
          [classNames]="classNames"
          [form]="form?.get('AUT')">
        </app-aut-form>
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="form?.get('OGT')"
      class="iccd-card-container">
      <mat-card-title title="Oggetto (OGT)">{{ 'Oggetto' }}</mat-card-title>
      <mat-card-content>
        <app-ogt-form
          [context]="{ TSK: form?.controls?.TSK.value }"
          [form]="form?.get('OGT')">
        </app-ogt-form>
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="form?.get('SGT')"
      class="iccd-card-container">
      <mat-card-title title="Soggetto (SGT)">{{ 'Soggetto' }}</mat-card-title>
      <mat-card-content>
        <app-sgt-form [form]="form?.get('SGT')"></app-sgt-form>
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="form?.get('DES')"
      class="iccd-card-container">
      <mat-card-title title="Descrizione (DES)">{{ 'Descrizione' }}</mat-card-title>
      <mat-card-content>
        <app-des-form [form]="form?.get('DES')"></app-des-form>
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="form?.get('ISR')"
      class="iccd-card-container">
      <mat-card-title title="Iscrizioni (ISR)">{{ 'Iscrizioni' }}</mat-card-title>
      <mat-card-content>
        <app-isr-form
          [classNames]="classNames"
          [form]="form?.get('ISR')">
        </app-isr-form>
      </mat-card-content>
    </mat-card>

    <mat-expansion-panel
      *ngIf="form?.get('NCT')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Codici' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-nct-form [form]="form?.get('NCT')"></app-nct-form>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="form?.get('STC')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Stato di conservazione' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-stc-form [form]="form?.get('STC')"></app-stc-form>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="form?.get('ACQ')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Acquisizione' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-acq-form [form]="form?.get('ACQ')"></app-acq-form>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="form?.get('CDG')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Condizione giuridica' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-cdg-form [form]="form?.get('CDG')"></app-cdg-form>
    </mat-expansion-panel>

    <mat-form-field>
      <input
        matInput
        placeholder="Notizie storico-critiche (NSC)"
        formControlName="NSC">
    </mat-form-field>

    <mat-expansion-panel
      *ngIf="form?.get('AGG')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Aggiornamento/revisione' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-agg-form
        [classNames]="classNames"
        [form]="form?.get('AGG')"></app-agg-form>
    </mat-expansion-panel>

    <mat-form-field>
      <input
        matInput
        placeholder="Livello ricerca (LIR)"
        formControlName="LIR">
    </mat-form-field>

    <mat-form-field *ngIf="form?.controls?.FIL">
      <input
        matInput
        placeholder="Filigrana (FIL)"
        formControlName="FIL">
    </mat-form-field>

    <mat-form-field *ngIf="form?.controls?.FRM">
      <input
        matInput
        placeholder="Forma (FRM)"
        formControlName="FRM">
    </mat-form-field>

    <app-input-vocabulary-autocomplete
      *ngIf="form?.controls?.MTX"
      formControlName="MTX"
      [vocabularyName]="'V_F_MTX'"
      [placeholder]="'(MTX)'">
    </app-input-vocabulary-autocomplete>

    <mat-form-field *ngIf="form?.controls?.LRO">
      <input
        matInput
        placeholder="Occasione (LRO)"
        formControlName="LRO">
    </mat-form-field>

    <mat-form-field *ngIf="form?.controls?.LRD">
      <input
        matInput
        placeholder="Data della ripresa (aaaa?-mm?-gg) (LRD)"
        formControlName="LRD">
      <mat-error *ngIf="form?.controls?.LRD?.hasError('iccdDate')">
        {{ 'Formato data non conforme allo standard ICCD' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-expansion-panel
      *ngIf="form?.get('EDT')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Editore / Stampatori' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-edt-form [form]="form?.get('EDT')"></app-edt-form>
    </mat-expansion-panel>
    <mat-expansion-panel
      *ngIf="form?.get('MIF')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Misure foglio' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-mif-form [form]="form?.get('MIF')"></app-mif-form>
    </mat-expansion-panel>
    <mat-expansion-panel
      *ngIf="form?.get('CPR')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Diritti d\'autore' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-cpr-form [form]="form?.get('CPR')"></app-cpr-form>
    </mat-expansion-panel>
    <mat-expansion-panel
      *ngIf="form?.get('ISE')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Iscrizioni' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-ise-form [form]="form?.get('ISE')"></app-ise-form>
    </mat-expansion-panel>
    <mat-expansion-panel
      *ngIf="form?.get('FVC')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Caratteristica fotografia digitale' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-fvc-form [form]="form?.get('FVC')"></app-fvc-form>
    </mat-expansion-panel>
    <mat-expansion-panel
      *ngIf="form?.get('UBF')"
      class="iccd-card-container">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'Ubicazione' }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-ubf-form [form]="form?.get('UBF')"></app-ubf-form>
    </mat-expansion-panel>
  </div>
</div>
